import ethers, { ContractInterface, Signer } from 'ethers';
import BaseContract from './BaseContract';

export default abstract class Base1155 extends BaseContract {
    constructor(contractAddress: string, abi: ContractInterface, signer: Signer | ethers.providers.Provider) {
        super(contractAddress, abi, signer);
    }

    async balanceOf(owner: string, id: number): Promise<number> {
        return await this.callFunction('balanceOf', [owner, id]);
    }

    async balanceOfBatch(owners: string[], ids: number[]): Promise<number[]> {
        return await this.callFunction('balanceOfBatch', [owners, ids]);
    }

    async setApprovalForAll(operator: string, approved: boolean, options: ethers.PayableOverrides = {}): Promise<any> {
        return await this.callFunction('setApprovalForAll', [operator, approved], options);
    }

    async isApprovedForAll(owner: string, operator: string): Promise<boolean> {
        return await this.callFunction('isApprovedForAll', [owner, operator]);
    }

    async safeTransferFrom(from: string, to: string, id: number, amount: number, data?: ethers.utils.BytesLike, options: ethers.PayableOverrides = {}): Promise<any> {
        const args = data ? [from, to, id, amount, data] : [from, to, id, amount];
        return await this.callFunction('safeTransferFrom', args, options);
    }

    async safeBatchTransferFrom(from: string, to: string, ids: number[], amounts: number[], data?: ethers.utils.BytesLike, options: ethers.PayableOverrides = {}): Promise<any> {
        const args = data ? [from, to, ids, amounts, data] : [from, to, ids, amounts];
        return await this.callFunction('safeBatchTransferFrom', args, options);
    }
}
